export const klaviyoTrack = (event, item) => {
  let _learnq = window._learnq || []
  _learnq.push(['track', event, item])
}
